import { MDBContainer } from "mdb-react-ui-kit";
import { FC } from "react";
import {
    interestedInSubTitle,
    interestedInTitle,
} from "@/utils/mockData/detailMocks";
import { TBreackpointsCarousel } from "@/models/common/common";
import { ToursEntity } from "@/models/home";
import SectionCarouselLayout from "../common/SectionCarouselLayout";
import CardTour from "../home/cards/cardTour/CardTour";

/* eslint-disable no-underscore-dangle */
const InterestedIn: FC<{ content: ToursEntity[] }> = ({ content }) => {
    const breackPointCarousel: TBreackpointsCarousel = {
        0: {
            slidesPerView: 1.3,
            height: 533,
            spaceBetween: 12,
        },
        576: {
            slidesPerView: 2,
            height: 533,
            spaceBetween: 12,
        },
        768: {
            slidesPerView: 2.5,
            height: 533,
            spaceBetween: 12,
        },
        992: {
            slidesPerView: 3,
            height: 533,
            spaceBetween: 12,
        },
        1200: {
            slidesPerView: 3.5,
            height: 533,
            spaceBetween: 32,
        },
        1400: {
            slidesPerView: 3.5,
            spaceBetween: 32,
            height: 568,
        },
        1600: {
            slidesPerView: 4.5,
            spaceBetween: 32,
            height: 568,
        },
        1920: {
            slidesPerView: 5.5,
            spaceBetween: 32,
            height: 568,
        },
    };

    return (
        <MDBContainer
            fluid
            className="py-5 px-0"
            style={{ backgroundColor: "#FCFCFC" }}
        >
            <SectionCarouselLayout
                visibleSlides={3.5}
                sectionTitle={interestedInTitle}
                sectionSubTitle={interestedInSubTitle}
                breakpointsCarousel={breackPointCarousel}
                isCarouselContained={false}
            >
                {content.map(item => (
                    <CardTour
                        className="mx-2 mx-md-0 m-4"
                        key={item._id}
                        content={item}
                    />
                ))}
            </SectionCarouselLayout>
        </MDBContainer>
    );
};
/* eslint-enable no-underscore-dangle */

export default InterestedIn;
